import { useCustomElement } from '@rcm/react-utils';
import { useCallback } from 'react';

/**
 * Produces a value change event callback to connect a field component to the containing custom element wrapper.
 *
 * When used in a custom element wrapper component, this produces a callback
 * that may be passed to the `onValueChange` handler of a field component. This
 * will cause the `value` property of the custom element to always be set to the
 * current value of the field component and will cause the custom element to
 * dispatch a `'change'` event when the
 * field component's value changes.
 */
const useCustomElementValueChangeCallback = () => {
  const element = useCustomElement();

  const onValueChange = useCallback(
    (value: string) => {
      Object.assign(element, { value });
      element.dispatchEvent(new Event('change'));
    },
    [element]
  );

  return onValueChange;
};

export default useCustomElementValueChangeCallback;
